/**
 * The school every school-API analytics call is scoped to.
 *
 * The head-office and campus analytics endpoints live on the school API and are
 * written for a logged-in school, so from the admin panel each request has to
 * name its school with `school_id`. A screen registers the school once here and
 * both services read it, which keeps the ported dashboard components unchanged.
 */

let schoolId: number | string | undefined;

export const setSchoolScopeId = (id: number | string | undefined) => {
  schoolId = id;
};

export const getSchoolScopeId = () => schoolId;

/** Every request carries the school scope alongside its own params. */
export const scoped = (params?: Record<string, any>) => ({
  school_id: schoolId,
  ...(params ?? {}),
});
